import axios from 'axios';
import LogRocket from 'logrocket';
import store from '@/store';

let environmentSuffix = 'development';
if (process.env.VUE_APP_MODE === 'production') environmentSuffix = 'production';

const isDev = process.env.VUE_APP_MODE === 'development' || process.env.NODE_ENV === 'development';

const createEventURL = `https://eventor-${environmentSuffix}.appspot.com/createEvent`;
const getCurrencyCodeByIpURL = `https://eventor-${environmentSuffix}.appspot.com/getCurrency`;
const getUpgradeEventSessionURL = `https://eventor-${environmentSuffix}.appspot.com/upgradeEvent`;
const addSubscriptionURL = `https://eventor-${environmentSuffix}.appspot.com/addSubscription`;
const addTeamMemberURL = `https://eventor-${environmentSuffix}.appspot.com/addTeamMember`;
const updateTeamMemberURL = `https://eventor-${environmentSuffix}.appspot.com/updateTeamMember`;
const removeTeamMemberURL = `https://eventor-${environmentSuffix}.appspot.com/deleteTeamMember`;
const refreshTeamMembersStatusURL = `https://eventor-${environmentSuffix}.appspot.com/refreshTeamMembersStatus`;
const intercomTokenURL = `https://eventor-${environmentSuffix}.appspot.com/intercomToken`;

const defaultConfig = {
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
};

async function getRequestConfig() {
  const requestConfig = defaultConfig;
  const authToken = await store.dispatch('user/auth/getAuthToken');

  requestConfig.headers.Authorization = `Bearer ${authToken}`;

  return requestConfig;
}

export async function APIGetCurrencyCodeByIP() {
  return axios.post(getCurrencyCodeByIpURL, {}, defaultConfig);
}

export async function APICreateEvent(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APICreateEvent', requestData);
  else LogRocket.info('# APICreateEvent', requestData);

  return axios.post(createEventURL, requestData, requestConfig);
}

export async function APIGetUpgradeEventSession(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APIGetUpgradeEventSession', requestData);
  else LogRocket.info('# APIGetUpgradeEventSession', requestData);

  return axios.post(getUpgradeEventSessionURL, requestData, requestConfig);
}

export async function APIAddSubscription(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APIAddSubscription', requestData);
  else LogRocket.info('# APIAddSubscription', requestData);

  return axios.post(addSubscriptionURL, requestData, requestConfig);
}

export async function APIAddTeamMember(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APIAddTeamMember', requestData);
  else LogRocket.info('# APIAddTeamMember', requestData);

  return axios.post(addTeamMemberURL, requestData, requestConfig);
}

export async function APIUpdateTeamMember(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APIUpdateTeamMember', requestData);
  else LogRocket.info('# APIUpdateTeamMember', requestData);

  return axios.post(updateTeamMemberURL, requestData, requestConfig);
}

export async function APIRefreshTeamMembersStatus() {
  const requestConfig = await getRequestConfig();

  return axios.post(refreshTeamMembersStatusURL, {}, requestConfig);
}

export async function APIRemoveTeamMember(requestData) {
  const requestConfig = await getRequestConfig();

  if (isDev) console.info('# APIRemoveTeamMember', requestData);
  else LogRocket.info('# APIRemoveTeamMember', requestData);

  return axios.post(removeTeamMemberURL, requestData, requestConfig);
}

/**
 * Intercom identity verification: a short-lived JWT for the signed-in user, signed by the backend.
 * Resolves to null when the backend has no Intercom secret yet, so the Messenger stays anonymous instead of
 * sending an unsigned user_id/email (which Intercom rejects once "Enforce Messenger Security" is on).
 */
export async function APIGetIntercomToken() {
  const requestConfig = await getRequestConfig();

  try {
    const { data } = await axios.post(intercomTokenURL, {}, requestConfig);
    return data && data.token ? data : null;
  } catch (error) {
    if (isDev) console.info('# APIGetIntercomToken failed', error.message);
    else LogRocket.info('# APIGetIntercomToken failed', error.message);
    return null;
  }
}
